import { inventoryProductService } from "../../../../../Api/Services/InventoryService/inventoryProduct";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";
import { IInventoryActionPayload, IInventoryActionResponse } from "../../types";


// --- Thunk ---
export const saveInventoryAction = createServiceAsyncThunk<
  IInventoryActionResponse,
  { formData: FormData }
>(
  ACTION_NAMES.SAVE_INVENTORY_ACTION,
  ({ formData }) => inventoryProductService.inventoryAction(formData),
  ERROR_MESSAGES.SAVE_INVENTORY_ACTION_FAILURE
);

// --- Slice ---
const saveInventoryActionSlice = createGenericSlice<
  IInventoryActionResponse,
  { formData: FormData }
>(
  SLICE_NAMES.SAVE_INVENTORY_ACTION_SLICE,
  saveInventoryAction
);

export const {
  clearError: clearSaveInventoryActionError,
  clearSuccessMessage: clearSaveInventoryActionSuccessMessage,
} = saveInventoryActionSlice.actions;

export default saveInventoryActionSlice.reducer;
